import React from "react";

import canvaImg from "../../../../assets/img/canva.png";
import googleImg from "../../../../assets/img/google.png";
import dropboxImg from "../../../../assets/img/dropbox.png";
import comcastImg from "../../../../assets/img/comcast.png";
import mooseendImg from "../../../../assets/img/mooseend.png";
import sendpulseImg from "../../../../assets/img/sendpulse.png";
import docuSignImg from "../../../../assets/img/docu-sign.png";
import "aos/dist/aos.css";
import "../../../../assets/styles/main.css";
import "../../../../assets/styles/responsive.css";
const HomeBrands = () => {
  return (
    <div class="home-brands">
      <div class="container">
        <div class="items-area">
          <div class="item aos-animate aos-init">
            <img src={canvaImg} class="img-fluid" alt="canva" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={googleImg} class="img-fluid" alt="google" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={dropboxImg} class="img-fluid" alt="dropbox" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={comcastImg} class="img-fluid" alt="comcast" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={mooseendImg} class="img-fluid" alt="moosend" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={sendpulseImg} class="img-fluid" alt="sendpulse" />
          </div>

          <div class="item aos-animate aos-init">
            <img src={docuSignImg} class="img-fluid" alt="docu-sign" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBrands;
